import { useSelector } from "react-redux";
import { useAppDispatch } from "../../hooks/redux";
import FilterCard from "./FilterCard";
import { getSelectedEnrollmentDates, setSelectedEnrollmentDates } from "../../services/students/studentsSlice";
import { Calendar } from "primereact/calendar";

const EnrollmentDateFilter = () => {
  const selectedEnrollmentDates = useSelector(getSelectedEnrollmentDates);
  const dispatch = useAppDispatch();

  return (
    <FilterCard title="По дата на записване:">
      <div className="flex flex-row">
        <Calendar
          value={selectedEnrollmentDates.startDate}
          onChange={(e) =>
            dispatch(setSelectedEnrollmentDates([e.value || null, selectedEnrollmentDates.endDate || null]))
          }
          showIcon
          className="w-full"
          placeholder="от"
          dateFormat="dd.mm.yy"
          showButtonBar
        />
        <Calendar
          value={selectedEnrollmentDates.endDate}
          onChange={(e) =>
            dispatch(setSelectedEnrollmentDates([selectedEnrollmentDates.startDate || null, e.value || null]))
          }
          showIcon
          className="w-full"
          placeholder="до"
          dateFormat="dd.mm.yy"
          showButtonBar
        />
      </div>
    </FilterCard>
  );
};

export default EnrollmentDateFilter;
